import boticarioConfig from './boticario';
import eudoraConfig from './eudora';

import type { Config } from './env';

let config: Config | undefined;

const DEFAULT_STORE = 'eudora';

const brands = [
  {
    config: eudoraConfig,
    host: 'eudora.com.br',
    name: 'eudora',
  },
  {
    config: boticarioConfig,
    host: 'boticario.com.br',
    name: 'boticario',
  },
];

const hostBrandName = brands.find(function (brand) {
  const re = new RegExp(brand.host);

  return re.test(window.location.host);
})?.name;

const brandName = hostBrandName ? hostBrandName : process.env.REACT_APP_BRAND || DEFAULT_STORE;

const getBrandConfig = () => {
  config = brands.find((brand) => brand.name === brandName)?.config;

  return config as Config;
};

export default getBrandConfig();
